import React from 'react'
import { Box, Combobox, Input } from '@node-space/ui-components'
import { BusinessCustomerDefaultValues } from '../helpers/form'
import { BusinessCustomerFormData, ConfirmBusinessCustomerMethod } from '../helpers/types'
import { useBusinessCustomerForm } from '../hooks/useBusinessCustomerForm'
import { AddCustomerActions } from './AddCustomerActions'

export interface AddBusinessCustomerProps {
  defaultValues: BusinessCustomerFormData
  onConfirm: ConfirmBusinessCustomerMethod
  onCancel: () => void
}

export const AddBusinessCustomer = ({
  defaultValues,
  onConfirm,
  onCancel,
}: AddBusinessCustomerProps) => {
  const { formFields, displayData, handleSubmit } = useBusinessCustomerForm(
    defaultValues ?? BusinessCustomerDefaultValues
  )

  const onSubmit = (data: BusinessCustomerFormData) => {
    onConfirm({ data, displayData })
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box flexCol gap={16}>
        <Input {...formFields?.businessName} inputMode="text" testId="business-name" />
        <Input {...formFields?.businessDescription} testId="business-description" />
        <Combobox {...formFields?.countryOfIncorporation} />
      </Box>
      <AddCustomerActions onCancel={onCancel} />
    </form>
  )
}
